import React, { useState, useEffect } from 'react'
import { Row, InputGroup, Form, Table, Modal, Button } from "react-bootstrap";
import { showToast } from '../reusables/CommonFunction';
import axiosInstance from '../../utils/axios';
import CustomPagination from '../reusables/CustomPagination';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';

export default function ModalICD({ ...props }) {
    const [loading, setLoading] = useState(false);
    const [icdCode, setICDCode] = useState("")
    const [icdDetails, setICDDetails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const pageSize = parseInt(process.env.REACT_APP_PAGINATION_PAGE_SIZE);

    const onPressICDCodes = () => {
        if (icdCode.length < 3) {
            showToast("error", "Please enter minimum 3 characters")
            return
        }
        setCurrentPage(1); // Reset to the first page
        fetchICDCodes(1)
    }

    const fetchICDCodes = (pageNumber) => {
        setLoading(true);
        axiosInstance
            .get(`/patients/get_ICD_codes/`, {
                params: {
                    q: icdCode,
                    page: pageNumber
                }
            })
            .then(response => {
                if (response.status === 200) {
                    if (response.data.data.length === 0) {
                        showToast("info", "No ICD codes found for the given search criteria.");
                        setICDDetails([]);
                        setTotalCount(0);
                    } else {
                        setICDDetails(response.data.data)
                        setTotalCount(response.data.count);
                    }
                }
            })
            .catch(error => {
                showToast("error", "Error while fetching ICD codes. Please try again.");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    const onPressSelectCode = (oEvent, pICD) => {
        oEvent.preventDefault();
        props.onPressSelectCode(pICD)
        setICDDetails([])
        setICDCode("")
        setCurrentPage(1)
    }

    useEffect(() => {
        if (icdCode.length >= 3) {
            fetchICDCodes(currentPage);
        }
    }, [currentPage]);

    useEffect(() => {
        if (props.show) {
            setICDCode("")
            setICDDetails([])
            setCurrentPage(1)
        }
    }, [props.show]);

    return (
        <Modal  {...props}
            size="lg" backdrop="static" keyboard={false} centered>
            <Modal.Header closeButton>
                <Modal.Title>Search ICD Codes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="ml-3 mr-3 mb-3">
                    <div className='col-md-12'>
                        <InputGroup className="mb-3 pl-0" >
                            <Form.Control
                                type="text"
                                name="icdCode"
                                onChange={(oEvent) => setICDCode(oEvent.target.value)}
                                placeholder="Enter Minimum 3 Characters..."
                            />
                            <Button type="submit" variant="outline-secondary" onClick={onPressICDCodes}>
                                Search
                            </Button>
                        </InputGroup>

                        {/* If the count is 0 then hide the table */}
                        {icdDetails.length > 0 ?
                            <>
                                <Table bordered hover responsive>
                                    <thead light="true">
                                        <tr>
                                            <th>#</th>
                                            <th>Code</th>
                                            <th>Short Description</th>
                                            <th>Long Description</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {icdDetails.map((icd, index) => {
                                            return [
                                                <tr key={icd.serial_number}>
                                                    <td>{icd.serial_number}</td>
                                                    <td>{icd.code}</td>
                                                    <td>{icd.short_description}</td>
                                                    <td>{icd.long_description}</td>
                                                    <td><Button type='button' variant='info' size='sm' onClick={(e) => onPressSelectCode(e, icd)} >Select</Button></td>
                                                </tr>
                                            ]
                                        })}
                                    </tbody>
                                </Table>

                                <CustomPagination
                                    totalCount={totalCount}
                                    currentPage={currentPage}
                                    pageSize={pageSize}
                                    onPageChange={setCurrentPage} />
                            </>
                            : <> </>}
                        <BusyLoaderOverlay show={loading} />
                    </div>
                </Row>
            </Modal.Body>
        </Modal>
    )
}

